const homeHelp = [
    {
        id: 1,
        text: "در این صفحه می‌توانید با توجه به نیاز خود، دوره مورد نظر خود را خریداری کنید."
    }
]

export default homeHelp